var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.existReservation === "N"
    ? _c("div", { staticClass: "akl" }, [
        _c("div", { staticClass: "bod-view-txt" }, [
          _c("div", { staticClass: "os_noticeRes taola_wrap" }, [
            _c("div", { staticClass: "widM padTM cont_Wrap" }, [
              _vm._m(0),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "widM NCACroa_cont01_wrap" }, [
                _c("div", { staticClass: " clearfix" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "NCACroa_cont01-1 padBM padTM NCACroa_cont01_input"
                    },
                    [
                      _c("span", { staticClass: "fntP bold" }, [
                        _vm._v("이름")
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "fntP bold colorRightGray" }, [
                        _vm._v(_vm._s(this.aboInfo.user_name))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "NCACroa_cont01-1 padBM padTM NCACroa_cont01_input"
                    },
                    [
                      _c("span", { staticClass: "fntP bold" }, [
                        _vm._v("ABO번호")
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "fntP bold colorRightGray" }, [
                        _vm._v(_vm._s(this.aboInfo.user_id))
                      ])
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _vm._m(3),
              _vm._v(" "),
              _vm._m(4),
              _vm._v(" "),
              _c("hr", {
                staticStyle: {
                  "border-top": "1px solid #ddd",
                  background: "#f4f4f4",
                  padding: "4.5px 0"
                }
              }),
              _vm._v(" "),
              _vm._m(5),
              _vm._v(" "),
              _c("hr", { staticStyle: { "border-top": "1px solid #e3e3e3" } }),
              _vm._v(" "),
              _c("div", { staticClass: "widM" }, [
                _c("div", { staticClass: "clearfix" }, [
                  _c(
                    "div",
                    { staticClass: "amway-theme" },
                    _vm._l(_vm.sessionList, function(item) {
                      return _c(
                        "div",
                        {
                          key: item.idx,
                          staticClass:
                            "radio-wrapper NCACroa_cont03_radio NCACroa_radioBtn"
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label focus disBl",
                              staticStyle: { "margin-bottom": "20px" }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedSessionId,
                                    expression: "selectedSessionId"
                                  }
                                ],
                                staticClass: "amw-global-radio",
                                attrs: {
                                  type: "radio",
                                  name: "radio-7",
                                  disabled: item.remainSeat <= 0
                                },
                                domProps: {
                                  value: item.session_id,
                                  checked: _vm._q(
                                    _vm.selectedSessionId,
                                    item.session_id
                                  )
                                },
                                on: {
                                  change: function($event) {
                                    _vm.selectedSessionId = item.session_id
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "amw-radio-overlay" }),
                              _vm._v(" "),
                              item.remainSeat > 0
                                ? _c(
                                    "span",
                                    { staticClass: "amw-label-radio-text" },
                                    [
                                      _vm._v(
                                        "\n                  <" +
                                          _vm._s(item.event_title) +
                                          ">\n                  "
                                      ),
                                      _c("b", [
                                        _vm._v(_vm._s(item.session_name))
                                      ]),
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(item.session_time) +
                                          "  \n                    "
                                      ),
                                      _c("br", { staticClass: "moOnly" })
                                    ]
                                  )
                                : _c(
                                    "span",
                                    {
                                      staticClass: "amw-label-radio-text",
                                      staticStyle: {
                                        color: "rgb(215, 211, 211)"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  <" +
                                          _vm._s(item.event_title) +
                                          ">\n                  "
                                      ),
                                      _c(
                                        "b",
                                        {
                                          staticStyle: {
                                            color: "rgb(215, 211, 211)"
                                          }
                                        },
                                        [_vm._v(_vm._s(item.session_name))]
                                      ),
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(item.session_time) +
                                          "  \n                  "
                                      ),
                                      _c("br", { staticClass: "moOnly" })
                                    ]
                                  )
                            ]
                          )
                        ]
                      )
                    }),
                    0
                  )
                ])
              ]),
              _vm._v(" "),
              _c("hr", {
                staticStyle: {
                  "border-top": "1px solid #e3e3e3",
                  margin: "15px 0 10px"
                }
              }),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass: "fntE txtL bold widM mo_padTS",
                  staticStyle: { color: "#d91734" }
                },
                [_vm._v("* 1세트 당 <타올라존> 티켓 2매를 제공해 드립니다.")]
              ),
              _vm._v(" "),
              _vm._m(6),
              _vm._v(" "),
              _c("div", { staticClass: "widM txtC marTML" }, [
                _c(
                  "button",
                  {
                    staticClass: "bt-akl-blue large NCACroa_submit",
                    attrs: {
                      id: "addToCart",
                      disabled:
                        this.selectedSessionId == null ||
                        this.aboInfo.user_id == null ||
                        this.aboInfo.user_name == null
                    },
                    on: { click: _vm.reservation }
                  },
                  [_vm._v("\n       신청하기\n      ")]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "padM disIb" },
                [
                  _c("Loading", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: this.isLoading,
                        expression: "this.isLoading"
                      }
                    ]
                  })
                ],
                1
              )
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "txtC padBM",
        staticStyle: { "border-bottom": "1px solid #ddd" }
      },
      [
        _c("img", {
          staticClass: "icoS",
          staticStyle: { "max-width": "115px" },
          attrs: {
            src:
              "https://www.amway.co.kr/_ui/_noticeImg/logo/logo_amway_ci.png",
            alt: "Amway (로고)"
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "taola_banner" }, [
      _c("img", {
        staticClass: "pcOnly",
        attrs: {
          src: require("../_images/img_banner_pc.png"),
          alt:
            "25cent ride 온 우주가 다타라!! 우주라이드 would u ride? 우주라이드 타올라존 티켓 신청 티켓 신청 기간 8월 3일 (목) ~ 한정수량"
        }
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "moOnly",
        attrs: {
          src: require("../_images/img_banner_mo.png"),
          alt:
            "25cent ride 온 우주가 다타라!! 우주라이드 would u ride? 우주라이드 타올라존 티켓 신청 티켓 신청 기간 8월 3일 (목) ~ 한정수량"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: { background: "#f4f4f4", "border-top": "2px solid #ddd" }
      },
      [
        _c("div", { staticClass: "widM padTS padBS taola_title" }, [
          _c(
            "div",
            { staticClass: "fntH4 bold", staticStyle: { color: "#2c2c2c" } },
            [_vm._v("참가자 정보")]
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "marTML mo_marTML1",
        staticStyle: { background: "#f4f4f4", "border-top": "2px solid #ddd" }
      },
      [
        _c("div", { staticClass: "widM padTS padBS taola_title" }, [
          _c(
            "div",
            { staticClass: "fntH4 bold", staticStyle: { color: "#2c2c2c" } },
            [_vm._v("세션 선택")]
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "widM txtC marTM" }, [
      _c("div", { staticClass: "marBML" }, [
        _c("div", [
          _c(
            "div",
            {
              staticClass: "osResTbScrollWrap",
              staticStyle: { border: "none", "box-shadow": "none" }
            },
            [
              _c("div", { staticClass: "osResTbScroll" }, [
                _c("img", {
                  staticClass: "pcOnly",
                  attrs: {
                    src: require("../_images/timeTable_pc_2.png"),
                    alt: ""
                  }
                }),
                _vm._v(" "),
                _c("img", {
                  staticClass: "moOnly",
                  attrs: {
                    src: require("../_images/timeTable_mo_2.png"),
                    alt: ""
                  }
                })
              ])
            ]
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "widM" }, [
      _c(
        "p",
        {
          staticClass: "fntH6 fntL bold padTS taola_sub_title",
          staticStyle: { color: "#222" }
        },
        [_vm._v("참가 신청하고자 하시는 날짜와 세션을 선택해주세요.")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "marTML mo_marTML2",
        staticStyle: { background: "#f7f7f7" }
      },
      [
        _c("div", { staticClass: "widM padTML padBML" }, [
          _c(
            "div",
            {
              staticClass: "fntH6 fntL bold taola_sub_title",
              staticStyle: { color: "#333" }
            },
            [_vm._v("알아 두세요!")]
          ),
          _vm._v(" "),
          _c("hr", { staticStyle: { "border-top": "1px solid #e3e3e3" } }),
          _vm._v(" "),
          _c("ul", { staticClass: "taola_notice fntP" }, [
            _c("li", [
              _vm._v("ABO 번호당 1세션 (한가지 세션) 신청 가능합니다.")
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "1세션 신청 시 <타올라존> 2매가 제공됩니다. (2매 모두 동일 세션으로 제공)"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "여러 개의 프로필로 150KM 미션을 달성했더라도 ABO 번호 1개당 티켓 최대 2매 선착순 신청이 가능합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "타올라존 체험은 오전 9시 30분~오후 8시까지 오전(09:30~13:00) / 오후(13:00~17:00) / 저녁(17:00~20:00) 3개 타임으로 나뉘어 운영됩니다. 단, 머슬핀 인정식이 진행되는 14:00-14:30에는 체험이 제한됩니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v("신청 마감된 세션은 추가로 신청하실 수 없습니다.")
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "신청하신 세션의 변경을 원하실 경우 취소 후 재신청하셔야 합니다. 취소 후 재신청 시 신청하고자 하는 세션이 마감되었을 경우 신청이 불가하며, 취소된 세션의 신청 내역 또한 복구가 불가능합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "세션 변경은 8월 10일 (목) 자정까지만 가능하며, 마감후에는 취소가 불가합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "우주라이드 현장에서 ABO 번호 확인 후 티켓으로 교환해 드립니다."
              )
            ])
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29f027e0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29f027e0","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/taola/wouldUride/WouldUrideTaolaEvent.vue
// module id = null
// module chunks = 